import React from 'react';
import { Check, CircleUserRound, CreditCard, PartyPopper } from 'lucide-react';

const Stepper = ({ currentStep }) => {
    const steps = [
        { name: 'Create Account', icon: <CircleUserRound /> },
        { name: 'Choose Plan', icon: <CreditCard /> },
        { name: 'Payment & Finish', icon: <PartyPopper /> },
    ];

    return (
        <div className="w-full max-w-2xl mx-auto px-4 sm:px-8">
            <div className="flex items-center">
                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isCompleted = currentStep > stepNumber;
                    const isCurrent = currentStep === stepNumber;

                    return (
                        <React.Fragment key={step.name}>
                            {/* Step Item */}
                            <div className="flex flex-col items-center text-center">
                                <div
                                    className={`flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 ring-4 ${isCurrent ? 'bg-orange-500 text-white ring-orange-200'
                                        : isCompleted ? 'bg-orange-500 text-white ring-orange-200'
                                            : 'bg-gray-100 text-gray-500 ring-gray-200'
                                        }`}
                                >
                                    {isCompleted ? <Check size={24} /> : React.cloneElement(step.icon, { size: 24 })}
                                </div>
                                <p
                                    className={`mt-2 text-sm font-semibold w-24 ${isCurrent || isCompleted ? 'text-orange-600' : 'text-gray-500'
                                        }`}
                                >
                                    {step.name}
                                </p>
                            </div>

                            {/* Connector Line */}
                            {index < steps.length - 1 && (
                                <div
                                    className={`flex-auto border-t-4 transition-colors duration-300 ${isCompleted ? 'border-orange-500' : 'border-gray-200'
                                        }`}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default Stepper;
